import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteComment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (commentId: string) => {
      const result = await apiClient.comment.deleteComment.mutation({ params: { commentId } });
      if (result.status !== 204) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments'] });
      toast.success(`Comment deleted!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting the comment!`);
    },
  });
};
